// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__aTCQb","gradient-animation":"NotFound_gradient-animation__EnckC"};